import SearchInput from '@features/search/ui/SearchInput'

export default function SearchModal () {
  return (
    <SearchInput
      openModalAfterFocus={false}
      showResults
      inModal
      focusAfterMount
    />
  )
}
